var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{class:_vm.heightSetting},[_c('div',{class:`${_vm.imageClass} ${_vm.heightSetting}`},[_c('div',{staticClass:"d-flex flex-column align-items-center h-100 justify-content-center text-center",class:_vm.textClass},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }